module.exports = __webpack_public_path__ + "static/media/looker.ca22bacc.svg";